import React from "react";

export const BubbleChat = ({ color = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_245_2699)">
        <path
          d="M15.0016 11.5544C16.5478 9.38513 16.3114 6.41309 14.1996 4.47713C13.2347 3.59259 12.0046 3.04194 10.6758 2.88816C10.6675 2.87797 10.6591 2.86787 10.6498 2.85822C9.49381 1.65744 7.83306 0.96875 6.09338 0.96875C2.78278 0.96875 0 3.43541 0 6.59375C0 7.70109 0.343969 8.76262 0.997375 9.67941L0.0845938 12.5452C0.0272188 12.7253 0.0836562 12.9222 0.227687 13.0447C0.371969 13.1673 0.5755 13.1908 0.743656 13.1053L3.5195 11.6938C4.08956 11.9393 4.69406 12.1004 5.32006 12.1737C6.52763 13.4435 8.19734 14.0938 9.90563 14.0938C10.7936 14.0938 11.6784 13.9128 12.4794 13.5688L15.2553 14.9803C15.3226 15.0145 15.3953 15.0312 15.4677 15.0312C15.784 15.0312 16.0108 14.723 15.9144 14.4202L15.0016 11.5544ZM3.70869 10.7507C3.57741 10.6883 3.42469 10.6904 3.29516 10.7563L1.31806 11.7616L1.96369 9.7345C2.01069 9.58691 1.98178 9.42566 1.88641 9.30363C1.26559 8.50894 0.937437 7.57191 0.937437 6.59375C0.937437 4.00906 3.25038 1.90625 6.09338 1.90625C7.23825 1.90625 8.34041 2.25309 9.23444 2.87769C6.22356 3.18044 3.81225 5.53212 3.81225 8.46875C3.81225 9.38212 4.04637 10.2614 4.48778 11.0492C4.22053 10.9697 3.96025 10.8701 3.70869 10.7507ZM12.7038 12.6312C12.5762 12.5663 12.4233 12.5624 12.2903 12.6257C11.5595 12.9728 10.7349 13.1562 9.90563 13.1562C7.06263 13.1562 4.74969 11.0534 4.74969 8.46875C4.74969 5.88406 7.06263 3.78125 9.90563 3.78125C12.7486 3.78125 15.0616 5.88406 15.0616 8.46875C15.0616 9.44691 14.7334 10.3839 14.1126 11.1786C14.0172 11.3006 13.9883 11.4619 14.0353 11.6095L14.6809 13.6365L12.7038 12.6312Z"
          fill={color}
        />
        <path
          d="M7.99902 8.9375C8.25791 8.9375 8.46777 8.72763 8.46777 8.46875C8.46777 8.20987 8.25791 8 7.99902 8C7.74014 8 7.53027 8.20987 7.53027 8.46875C7.53027 8.72763 7.74014 8.9375 7.99902 8.9375Z"
          fill={color}
        />
        <path
          d="M9.87402 8.9375C10.1329 8.9375 10.3428 8.72763 10.3428 8.46875C10.3428 8.20987 10.1329 8 9.87402 8C9.61514 8 9.40527 8.20987 9.40527 8.46875C9.40527 8.72763 9.61514 8.9375 9.87402 8.9375Z"
          fill={color}
        />
        <path
          d="M11.749 8.9375C12.0079 8.9375 12.2178 8.72763 12.2178 8.46875C12.2178 8.20987 12.0079 8 11.749 8C11.4901 8 11.2803 8.20987 11.2803 8.46875C11.2803 8.72763 11.4901 8.9375 11.749 8.9375Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_245_2699">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
